import styled from "styled-components";

import Heading from "../Heading";

import { default as breakpoints } from "./breakpoints";
import { spacing2020HasBreakpoints } from "./spacing";
import { P } from "./Typography";
import { regular as regularFontWeight } from "./fontStyles";

import { colors } from "./colors";

const MarketingPageSectionEyebrowSubheading = styled(P).attrs({
    bold: true
})`
    text-transform: uppercase;
    font-size: 0.7188rem; /* 11.5px custom size */
    line-height: 100%;
    letter-spacing: 0.0625rem;
    ${spacing2020HasBreakpoints.SpacingXS}
    text-align: center;
`;

const MarketingPageSectionHeading = styled(Heading)`
    color: ${colors.dark};

    /* Headings that are preceded by EyebrowSubHeadings
    have different spacing than those that aren't */
    ${MarketingPageSectionEyebrowSubheading} + & {
        ${spacing2020HasBreakpoints.SpacingLG}
    }
`;

const MarketingPageSectionBiLine = styled.p`
    ${regularFontWeight}
    font-size: 0.875rem; /* 14px custom */
    line-height: 1.3125rem;
    text-align: center;

    /* Tablet: */
    @media (min-width: ${breakpoints.md}rem) {
        line-height: 1.4rem;
    }

    /* Desktop: */
    @media (min-width: ${breakpoints.lg}rem) {
        font-size: 1rem; /* 16px custom */
        line-height: 1.625rem;
    }
`;

const MarketingPageSectionHeadingContainer = styled.div`
    color: ${colors.dark};
    margin: 0 auto;
    text-align: center;
    width: 100%;

    @media (min-width: ${breakpoints.md}rem) {
        max-width: 38.75rem;
    }

    @media (min-width: ${breakpoints.lg}rem) {
        max-width: 43.75rem;
    }
`;

export {
    MarketingPageSectionHeadingContainer,
    MarketingPageSectionEyebrowSubheading,
    MarketingPageSectionHeading,
    MarketingPageSectionBiLine
};
